if (!customElements.get('collection-review-section')) {
  customElements.define(
    'collection-review-section',
    class ReviewSection extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('[id^="Review-section-"]');
    
        if (!this.slider || typeof Swiper === 'undefined') return;
        this.init();
      }
    
      init() {
        const { 
          desktopSlides: d = 4, 
          laptopSlides: l = 3, 
          tabletSlides: t = 2, 
          mobileSlides: m = 1 
        } = this.dataset;
    
        const options = {
          slidesPerView: parseFloat(m),
          spaceBetween: 10,
          loop: true,
          navigation: this.getNav(),
          pagination: this.getPagination(),
          breakpoints: {
            750:  { slidesPerView: parseFloat(t), spaceBetween: 24 },
            990:  { slidesPerView: parseFloat(l), spaceBetween: 24 },
            1366: { slidesPerView: parseFloat(d), spaceBetween: 24 }
          }
        };
    
        this.swiper = new Swiper(this.slider, options);
      }
    
      getNav() {
        const next = this.querySelector('[id^="Review-next-"]');
        const prev = this.querySelector('[id^="Review-prev-"]');
        return (next && prev) ? { enabled: true, nextEl: next, prevEl: prev } : false;
      }
    
      getPagination() {
        const el = this.querySelector('[id^="Review-pagination-"]');
        return el ? { el, clickable: true } : false;
      }
    }
  )
}